import React from 'react'
import { Mail, Linkedin, Github, MapPin, Shield } from 'lucide-react'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="relative py-12 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-primary to-secondary flex items-center justify-center text-white font-bold text-xl font-display">
                <img
                  src="/images/mahesh-logo.png"
                  alt="MJ"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <span className="font-display font-bold text-xl tracking-tight text-white">
                Mahesh<span className="text-primary">.</span>
              </span>
            </div>
            <p className="text-gray-400 text-sm">
              Senior AI/ML Engineering Leader with 19+ years architecting production AI systems.
            </p>
          </div>

          <div className="space-y-4">
            <h4 className="font-display font-semibold text-white">Quick Links</h4>
            <div className="grid grid-cols-2 gap-2 text-sm">
              <a href="#about" className="text-gray-400 hover:text-primary transition-colors">About</a>
              <a href="#experience" className="text-gray-400 hover:text-primary transition-colors">Experience</a>
              <a href="#projects" className="text-gray-400 hover:text-primary transition-colors">Projects</a>
              <a href="#expertise" className="text-gray-400 hover:text-primary transition-colors">Expertise</a>
              <a href="#impact" className="text-gray-400 hover:text-primary transition-colors">Impact</a>
              <a href="#contact" className="text-gray-400 hover:text-primary transition-colors">Contact</a>
            </div>
          </div>

          <div className="space-y-4">
            <h4 className="font-display font-semibold text-white">Connect</h4>
            <div className="flex gap-4">
              <a href="mailto:jmaheshrao@gmail.com" className="glass w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-primary hover:border-primary/50 transition-all">
                <Mail size={20} />
              </a>
              <a href="https://linkedin.com/in/jmaheshrao" target="_blank" rel="noopener noreferrer" className="glass w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-primary hover:border-primary/50 transition-all">
                <Linkedin size={20} />
              </a>
              <a href="https://github.com/jmaheshrao" target="_blank" rel="noopener noreferrer" className="glass w-10 h-10 rounded-lg flex items-center justify-center text-gray-400 hover:text-primary hover:border-primary/50 transition-all">
                <Github size={20} />
              </a>
            </div>
            <div className="flex items-center gap-2 text-gray-400 text-sm">
              <MapPin size={16} />
              <span>San Jose, CA</span>
            </div>
          </div>
        </div>

        {/* Copyright and Content Protection Notice */}
        <div className="mt-12 pt-8 border-t border-white/5">
          <div className="flex flex-col items-center space-y-4">
            {/* Main Copyright */}
            <p className="text-gray-400 text-sm text-center">
              &copy; {currentYear} Mahesh Jammalamadaka. All rights reserved.
            </p>

            {/* Content Protection Notice */}
            <div className="glass rounded-xl p-4 max-w-3xl">
              <div className="flex items-start gap-3">
                <Shield className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                <div className="text-xs text-gray-500 space-y-2">
                  <p>
                    <span className="text-gray-400 font-semibold">Protected Content:</span> All content on this website, including but not limited to text, images, graphics, logos, photographs, project screenshots, code samples, and design elements, is the exclusive intellectual property of Mahesh Jammalamadaka.
                  </p>
                  <p>
                    <span className="text-gray-400 font-semibold">Usage Restrictions:</span> No part of this website may be reproduced, distributed, modified, displayed, published, or transmitted in any form without prior written permission from Mahesh Jammalamadaka. Unauthorized use, copying, or distribution of any content is strictly prohibited and may result in legal action.
                  </p>
                  <p>
                    <span className="text-gray-400 font-semibold">Permission Requests:</span> For licensing inquiries or permission to use any content, please contact{' '}
                    <a href="mailto:jmaheshrao@gmail.com" className="text-primary hover:underline">
                      jmaheshrao@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* Additional Legal Links */}
            <p className="text-gray-600 text-xs">
              By accessing this website, you agree to respect all intellectual property rights.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
